import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { resolveImg } from "@/lib/img";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const idSafe = product.id;

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link to={`/products/${product.id}`}
          data-testid={`product-card-${idSafe}`}
          className="group product-card block bg-white rounded-xl border border-gray-100 overflow-hidden">
      <div className="relative aspect-square overflow-hidden bg-[#F6F5F2]">
        <img src={resolveImg(product.image_url)} alt={product.name}
             className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
        {product.is_featured && (
          <span className="absolute top-3 left-3 text-[10px] font-bold tracking-wider uppercase bg-[#E48967] text-white px-2 py-1 rounded-full">
            Best Seller
          </span>
        )}
      </div>
      <div className="p-4">
        <div className="text-[11px] uppercase tracking-wider text-[#638971] font-semibold">{product.category}</div>
        <div className="mt-1 font-heading font-semibold text-[#1A1A1A] line-clamp-2 min-h-[48px]">
          {product.name}
        </div>
        <div className="mt-3 flex items-center justify-between">
          <div className="font-heading text-lg font-bold text-[#2C4035]">${product.price.toFixed(2)}</div>
          <button data-testid={`add-to-cart-btn-${idSafe}`}
                  onClick={handleAdd}
                  aria-label="Add to cart"
                  className="w-9 h-9 rounded-full bg-[#638971] hover:bg-[#4F705B] text-white grid place-items-center transition-colors">
            <Plus size={16}/>
          </button>
        </div>
      </div>
    </Link>
  );
}
